<template>
  <div class="main">
    <div class="row infos">
      <div class="col-xl-4 col-lg-12">
        <div class="blc-dados">
          <img src="/img/icon-grups.png" alt="icone prospect" />
          <p v-html="isEdit ? 'Edit Prospect' : 'New Prospect'"></p>
        </div>
      </div>
    </div>

    <div class="preview-wrapper d-flex w-100">
      <div 
        class="fundo form-box"
        :class="[
          'transition-all',
          showPreview ? 'w-60 pr-2' : 'w-100'
        ]"
      >
        <div class="blc-inf-geral">
          <div class="blc-item">
            <h2>Prospect Details</h2>
            <div class="row">
              <div class="col-xl-12 order-xl-1">
                <form @submit.prevent>
                  <h3>General Information</h3>

                  <div class="row mb-3">
                    <div class="col-lg-6">
                      <base-input
                        required
                        label="E-mail Subject"
                        placeholder="Ex: Prospect 1"
                        v-model="model.title"
                        :errors="errors.title"
                      />
                      <span class="form-text text-muted ml-2">
                        Obs: This will be used as the subject of the email
                      </span>
                    </div>

                    <div class="col-lg-3">
                      <multiple-select
                        :multiple="false"
                        label="Status"
                        :options="[{id: 1, name: 'Active'}, {id: 0, name: 'Inactive'}]"
                        v-model="model.status"
                        :errors="errors.status"
                      />
                    </div>

                    <div class="col-lg-3">
                      <multiple-select
                        :multiple="false"
                        label="Vessel (Navio)"
                        placeholder="Select a vessel"
                        :options="navios_options"
                        v-model="model.navio_id"
                        :errors="errors.navio_id"
                        required
                      />
                    </div>
                  </div>

                <div class="row mb-3">
                  <div class="col-lg-3">
                    <multiple-select
                      :multiple="false"
                      label="Responsible User"
                      placeholder="Select responsible"
                      :options="authorized_users"
                      v-model="model.user_id"
                      :errors="errors.user_id"
                      required
                    />
                  </div>

                    <div class="col-lg-9">
                      <multiple-select
                        multiple
                        label="Prospect Customers"
                        placeholder="Select customers"
                        :options="users"
                        v-model="model.customer_ids"
                        :errors="errors.customer_ids"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="form-group has-label">
                  <label class="form-control-label">
                    REMARKS
                  </label>
      
                  <ckeditor
                    :editor="editor"
                    :config="editorConfig"
                    v-model="model.remarks"
                    @ready="onEditorReady"
                  ></ckeditor>
      
                  <small class="text-danger" v-if="errors.remarks">
                    {{ errors.remarks[0] }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div
        v-if="showPreview"
        class="preview-box"
      >
        <div class="fundo">
          <div class="blc-inf-geral">
            <div class="blc-item" style="padding: 88px 40px !important;">
              <h2>Email preview</h2>
              <div class="iframe-wrapper">
                <iframe
                  v-if="emailPreview"
                  class="email-iframe"
                  :srcdoc="emailPreview"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 btn-final txt-right pt-2">
        <input
          type="button"
          :disabled="!model.navio_id"
          :class="['submit-branco', !model.navio_id ? 'disabled-btn' : '']"
          class="submit-branco"
          :value="showPreview ? 'Hide' : 'Show Email Preview'"
          @click="togglePreview"
        />
        <input
          type="submit"
          class="submit-branco"
          value="See listing"
          @click="$router.push('/prospects/listar')"
        />
        <button
          type="submit"
          class="submit"
          :disabled="loading"
          @click="submit()"
        >
          <i class="fa fa-spinner fa-spin" v-if="loading"></i> {{ isEdit ? 'Update' : 'Save' }} Prospect
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "@/services/Prospects";
import NaviosService from "@/services/Navios";
import UsuariosService from "@/services/Usuarios";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadAdapter from "@/UploadAdapter";
import { getCargoPlanTableHTML } from "./components/TableTemplate";
import { normalizeProspectTables } from "@/assets/js/prospects/utils/editorTableUtils";
import { setupEditor } from "@/assets/js/prospects/utils/editorSetup";

export default {
  name: "prospect_form",
  created() {
    NaviosService.get({ onlyNaabsa: true }).then((response) => {
      this.navios = response.data;
      this.navios_options = response.data.map((navio) => ({
        id: navio.id,
        name: navio.name_with_client_type,
      }));
    });

    UsuariosService.get({}).then(({ data }) => (this.users = data));

    Service.getUsers({}).then(({ data }) => (this.authorized_users = data));

    if (this.$route.params.id) {
      this.model.id = this.$route.params.id;
      this.find();
    }
  },
  data() {
    return {
      showPreview: false,
      editor: ClassicEditor,
      editorConfig: {
      height: 600,

      removePlugins: ['TableColumn'], 

      table: {
        contentToolbar: [
          'tableRow',
          'mergeTableCells',
          'tableProperties',
          'tableCellProperties'
        ]
      },

      htmlSupport: {
        allow: [
          {
            name: /.*/,
            attributes: true,
            classes: true,
            styles: true
          }
        ]
      },

      image: {
        resizeOptions: [
          {
            name: 'resizeImage:original',
            value: null,
            label: 'Original'
          },
          {
            name: 'resizeImage:50',
            value: '50',
            label: '50%'
          },
          {
            name: 'resizeImage:75',
            value: '75',
            label: '75%'
          }
        ],
        toolbar: [
          'imageStyle:inline',
          'imageStyle:block',
          'imageStyle:side',
          '|',
          'toggleImageCaption',
          'imageTextAlternative',
          '|',
          'resizeImage'
        ]
      },

      extraPlugins: [
        function (editor) {
          editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return new UploadAdapter(loader, '/prospects/upload');
          };
        },
      ],
    },
      errors: {},
      loading: false,
      navios: [],
      navios_options: [],
      users: [],
      authorized_users: [],
      isEdit: false,
      model: {
        id: null,
        title: "",
        navio_id: null,
        user_id: null,
        status: 1,
        customer_ids: [],
        remarks: ""
      },
      emailPreview: "",
      isNormalizingEditorTables: false,
      normalizeTablesTimer: null,
    };
  },
  methods: {
    async togglePreview() {
      this.showPreview = !this.showPreview;

      if (this.showPreview) {
        await this.loadPreview();
      }
    },
    cleanHtml(html) {
      const temp = document.createElement('div');
      temp.innerHTML = html;

      temp.querySelectorAll('img').forEach(el => {
        el.style.maxWidth = '100%';
        el.style.height = 'auto';
      });

      temp.querySelectorAll('td, th').forEach(el => {
        el.removeAttribute('width');

        const style = el.getAttribute('style');
        if (style) {
          let newStyle = style
            .replace(/width\s*:\s*[^;]+;?/gi, '')
            .replace(/min-width\s*:\s*[^;]+;?/gi, '')
            .replace(/max-width\s*:\s*[^;]+;?/gi, '');

          newStyle = newStyle.trim();

          if (newStyle) {
            el.setAttribute('style', newStyle);
          } else {
            el.removeAttribute('style');
          }
        }
      });

      return temp.innerHTML;
    },
    find() {
      this.loading = true;

      Service.find(this.model.id, { with: ["customerProspect", "navio", "user"] })
        .then(({ data }) => {
          this.model = data;
          this.model.customer_ids = data.customer_prospect 
            ? data.customer_prospect.map(cp => cp.customer_id)
            : [];

          this.isEdit = true;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    scheduleNormalizeEditorTables(editor) {
      if (this.normalizeTablesTimer) {
        clearTimeout(this.normalizeTablesTimer);
      }

      this.normalizeTablesTimer = setTimeout(() => {
        if (this.isNormalizingEditorTables) return;

        const currentData = editor.getData();
        if (!currentData || !currentData.includes("<table")) return;

        const normalizedData = normalizeProspectTables(currentData);

        if (normalizedData === currentData) return;
        this.isNormalizingEditorTables = true;
        editor.setData(normalizedData)
          .then(() => {
            this.isNormalizingEditorTables = false;
            this.model.remarks = normalizedData;
          })
          .catch(() => {
            this.isNormalizingEditorTables = false;
          });

      }, 120);
    },

  onEditorReady(editor) {
    setupEditor(editor, getCargoPlanTableHTML);

    editor.model.document.on("change:data", () => {
      this.scheduleNormalizeEditorTables(editor);
    });
    this.scheduleNormalizeEditorTables(editor);
  },

  async loadPreview() {
    try {
      const normalizedRemarks = normalizeProspectTables(this.model.remarks);
      if (normalizedRemarks !== this.model.remarks) {
        this.model.remarks = normalizedRemarks;
      }

      const navio = this.navios.find(n => n.id === this.model.navio_id);
      const payload = {
        ...this.model,
        remarks: this.cleanHtml(this.model.remarks),
        navio_name: navio ? navio.name : ''
      };

      const { data } = await Service.emailPreview(payload);
      this.emailPreview = data;

    } catch (e) {
      console.error(e);
    }
  },

  submit() {
    this.loading = true;
    this.errors = {};

    this.model.remarks = normalizeProspectTables(this.model.remarks);
    this.model.remarks = this.cleanHtml(this.model.remarks);

      const payload = {
        ...this.model,
        customers: this.model.customer_ids.map(id => ({ customer_id: id }))
      };

      Service.submit(payload)
        .then(() => {
          const message = this.model.id ? "Prospect updated successfully!" : "Prospect saved successfully!"
          this.$notify({
            type: "success",
            message: message,
          });
          this.$router.push("/prospects/listar");
        })
        .catch((err) => {
          this.loading = false;
          if (err.response?.data?.errors) {
            this.errors = err.response.data.errors;
          }
          else if (err.response?.data) {
            this.$notify({
              type: "danger",
              message: err.response?.data,
            });
          }
        });
    }
  },
};
</script>

<style>

.text-muted{
  font-size: 11px;
}

.multiselect__single {
  font-size: 12px !important;
}

.disabled-btn {
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: none;
}

.preview-wrapper {
  display: flex;
  gap: 12px;
  width: 100%;
  overflow: hidden; 
}

.form-box {
  flex: 1;
  min-width: 0; 
}

.preview-box {
  flex: 0 0 40%;
  min-width: 0;
  max-width: 100%;
}

.iframe-wrapper {
  width: 100%;
}

.email-iframe {
  width: 100%;
  height: 800px;
  border: none;
  display: block;
}

@media (max-width: 1730px) {
  .preview-box {
    min-width: 500px;
  }
}

@media (max-width: 1500px) {
  .preview-wrapper {
    flex-direction: column;
  }

  .preview-box {
    width: 100%;
    min-width: unset;
  }
}
@media (max-width: 675px) {
  .iframe-wrapper {
    width: 100%;
    overflow-x: auto;
  }

  .email-iframe {
    width: 800px;
    min-width: 800px;
    height: 800px;
  }
}
</style>